import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { StreamWebsocketInstance } from '../StreamWebsocketInstance';

export const useCloseStreamOnNavigate = () => {
  const history = useHistory();

  useEffect(
    () =>
      history.listen(() => {
        StreamWebsocketInstance.get().close();
      }),
    [history]
  );
};
